// extracted by mini-css-extract-plugin
export default {"imageWrapper":"yK-z","hovered":"zK-z","hoverImage":"AK-z","mainImage":"BK-z","imageNoBackground":"CK-z","fullSizeImage":"DK-z"};